import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { GetStatusId, UpdateStatus } from '../../../services/OnbordingService';
import './UpdateStatus.css';

import ConfirmationModal from '../../../common/modal/ConfirmationModal';
import { AppContext } from '../../../AppContext';

export default function UpdateStatusComponent() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setCurrentStep } = useContext(AppContext);
  const emailStatuSend = location?.state?.emailStatuSend || '';
  const businessname = location?.state?.business_name || '';
  const statusId = location?.state?.statusId || null;
  const [selectedStatus, setSelectedStatus] = useState('');
  const [currentStatus, setCurrentStatus] = useState('');
  const [isStatusUpdated, setIsStatusUpdated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const statusOptions = [
    { label: 'Queued', value: 'Queued' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Submitted to T-Mobile', value: 'Submitted to T-Mobile' },
    { label: 'On Hold', value: 'On Hold' },
    { label: 'Approved', value: 'Approved' },
    { label: 'Onboarding Completed', value: 'Onboarding Completed' },
    { label: 'Denied', value: 'Denied' },
  ];

  const mapStatusToDropdownValue = (status_id) => {
    switch (status_id) {
      case 1: return 'Queued';
      case 2: return 'Pending';
      case 3: return 'Submitted to T-Mobile';
      case 7: return 'On Hold';
      case 4: return 'Approved';
      case 5: return 'Onboarding Completed';
      case 6: return 'Denied';
      default: return '';
    }
  };

  useEffect(() => {
    if (statusId != null) {
      const mappedStatus = mapStatusToDropdownValue(Number(statusId));
      setSelectedStatus(mappedStatus);
      setCurrentStatus(mappedStatus);
    }
  }, [statusId]);


  useEffect(() => {
    if (isStatusUpdated) {
      setCurrentStep(9);
      navigate('/updatedSuccessfully');
    }
  }, [isStatusUpdated, navigate]);

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const handleUpdate = async () => {
    if (selectedStatus === "Approved") {
      setShowModal(true);
      return;
    }

    setLoading(true);
    try {
      const payload = {
        email: emailStatuSend,
        status: selectedStatus,
      };
      const response = await UpdateStatus(payload);
      if (response) {
        handleSearch();
        setIsStatusUpdated(true);
        setCurrentStatus(selectedStatus);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = async () => {
    try {
      const response = await GetStatusId(emailStatuSend);
      if (response) {
        // Handle response if needed
      }
    } catch (error) {
      console.error('Error fetching status:', error);
    }
  };

  const handleConfirm = async () => {
    setShowModal(false);
    await handleUpdateConfirmed();
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleUpdateConfirmed = async () => {
    setLoading(true);
    try {
      const payload = {
        email: emailStatuSend,
        status: selectedStatus,
      };
      const response = await UpdateStatus(payload);
      if (response) {
        handleSearch();
        setIsStatusUpdated(true);
        setCurrentStatus(selectedStatus);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ConfirmationModal
        show={showModal}
        message="Please confirm if you have sent the DocuSign link to the customer."
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
      <div className="updated-container">
        <div className="status-label-div">
          <label>Email:</label>
          <p className="current-status-label">{emailStatuSend}</p>
        </div>

        <div className="status-label-div">
          <label>Current Status:</label>
          <p className="current-status-label">{currentStatus}</p>
        </div>
        <div className="status-label-div">
          <label>Business Name:</label>
          <p className="current-status-label">{businessname}</p>
        </div>
        <label htmlFor="statusDropdown">Update Your Status:</label>
        <select
          id="statusDropdown"
          value={selectedStatus}
          onChange={handleStatusChange}
        >
          {statusOptions.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

        <div className="flex-btn">
          <button
            className="button-status"
            onClick={handleUpdate}
            disabled={loading}
          >
            Update Status
          </button>
          <button
            className="button-reset"
            onClick={() => navigate('/emailSearch')}
          >
            Reset
          </button>
        </div>
      </div>
    </>
  );
}
